import { gql } from '@apollo/client';

const ADD_PROJECT = gql`
  mutation ($input: AddProjectInput!) {
    addProject(input: $input) {
      name
      description
      parcels {
        parcelNumber
        coordinates {
          lat
          lng
        }
        items {
          type
          numberOfItems
          coordinates {
            lat
            lng
          }
        }
      }
    }
  }
`;

const GET_PROJECTS = gql`
  query {
    projects {
      items {
        createdAt
        id
        name
        description
        parcels {
          parcelNumber
          coordinates {
            lat
            lng
          }
          items {
            type
            numberOfItems
            coordinates {
              lat
              lng
            }
          }
        }
      }
    }
  }
`;

export { ADD_PROJECT, GET_PROJECTS };
